module.exports = __webpack_public_path__ + "media/images/Group 13-056b47ea9f2765fc0522d40e0f56caba.svg";